var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 8,
    viewBox: "0 0 21 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16553 7.5C4.16553 7.77614 4.38938 8 4.66553 8C4.94167 8 5.16553 7.77614 5.16553 7.5L4.16553 7.5ZM5.01908 0.146447C4.82382 -0.0488157 4.50724 -0.0488157 4.31197 0.146447L1.12999 3.32843C0.934731 3.52369 0.934731 3.84027 1.12999 4.03553C1.32526 4.2308 1.64184 4.2308 1.8371 4.03553L4.66553 1.20711L7.49395 4.03553C7.68922 4.2308 8.0058 4.2308 8.20106 4.03553C8.39632 3.84027 8.39632 3.52369 8.20106 3.32843L5.01908 0.146447ZM5.16553 7.5L5.16553 0.5L4.16553 0.5L4.16553 7.5L5.16553 7.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6655 6.99988L10.6655 6.99988",
    stroke: "#111827",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6655 4L10.6655 4",
    stroke: "#111827",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6655 1L10.6655 1",
    stroke: "#111827",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsc);
export default __webpack_public_path__ + "static/media/asc.9e227757bbb217c96851584647d143d7.svg";
export { ForwardRef as ReactComponent };